<h2 mat-dialog-title appLocalizationPopupDirective localizationCode="AssignToilPolicy">{{ 'AssignToilPolicy' | translate: {Default: "Assign Time Off In Lieu Policy"} }}</h2>

<mat-dialog-content>
    <form class="form-container" *ngIf="form && toilTypeOptions.length > 0; else loading" [formGroup]="form">

        <mat-form-field appearance="fill" appLocalizationPopupDirective localizationCode="ToilType">
            <mat-label>
                {{ 'ToilType' | translate: {Default: "Time Off In Lieu Type"} }}
            </mat-label>

            <mat-select
                disableOptionCentering
                formControlName="type"
                (selectionChange)="setSelectedToilType($event)">
                <mat-option></mat-option>
                <ng-container *ngIf="toilTypeOptions.length > 0">
                    <mat-option *ngFor="let option of toilTypeOptions" [value]="option.id">{{option.name}}</mat-option>
                </ng-container>
            </mat-select>
        </mat-form-field>

        <mat-form-field appearance="fill" appLocalizationPopupDirective localizationCode="ToilPolicy">
            <mat-label>
                {{ 'ToilPolicy' | translate: {Default: "Time Off In Lieu Policy"} }}
            </mat-label>

            <mat-select disableOptionCentering formControlName="policy">
                <mat-option></mat-option>
                <ng-container *ngIf="selectedToilPolicies.length > 0">
                    <mat-option *ngFor="let option of selectedToilPolicies" [value]="option.id">{{option.name}}</mat-option>
                </ng-container>
            </mat-select>
        </mat-form-field>

    </form>

    <ng-template #loading>
        <ngx-skeleton-loader
            count="5"
            [theme]="{
                'height.px': 50
            }"
        ></ngx-skeleton-loader>
    </ng-template>
</mat-dialog-content>

<mat-dialog-actions>
    <button mat-raised-button appPreventDoubleClick (throttledClick)="close()">{{ 'Close' | translate: {Default: "Close"} }}</button>
    <button mat-raised-button setColor="primaryColour" color="primary" appPreventDoubleClick (throttledClick)="save()" [disabled]="!form.valid" *ngIf="form">{{ 'Save' | translate: {Default: "Save"} }}</button>
</mat-dialog-actions>
